import React, { Component } from 'react';
import { Navigate, NavLink } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { Header } from './Header';
import { Footer } from './Footer';
import Base from './Base';

const customStyles = {
    headCells: {
        style: {
            fontSize: '12px', // تغییر اندازه فونت برای سرستون‌ها
        },
    },
    cells: {
        style: {
            fontSize: '12px', // تغییر اندازه فونت برای سلول‌ها
        },
    },
};

export default class PricingRemittance extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'pricing',
            data: null,
            loading: true,
            page: 1,
            per_page: 10,
            phrase: '',
            startDate: '',
            endDate: '',
            pricingMethod: 'FIFO', // مقدار پیش‌فرض
            activeTab: 'list' // تب فعال پیش‌فرض
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleFetchRemittances = this.handleFetchRemittances.bind(this);
        this.handlePriceDocuments = this.handlePriceDocuments.bind(this);
        this.handleTabClick = this.handleTabClick.bind(this);
    }

    componentDidMount() {
        this.refreshData();
    }

    handleInputChange(event) {
        const { name, value } = event.target;
        this.setState({
            [name]: value
        });
    }

    async handleFetchRemittances(event) {
        event.preventDefault();
        const payload = {
            //startDate: this.state.startDate,
            //endDate: this.state.endDate,
        };

        try {
            const response = await fetch(`/api/v1/${this.state.controllerName}/get`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            const result = await response.json();
            if (result.status === 1) {
                this.setState({ data: result.documents });
            } else {
                // مدیریت خطا
                console.error('Error:', result.message);
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }

    async handlePriceDocuments(event) {
        event.preventDefault();
        const payload = {
            pricingMethod: this.state.pricingMethod,
            //startDate: this.state.startDate,
            //endDate: this.state.endDate,
        };

        try {
            const response = await fetch(`/api/v1/${this.state.controllerName}/priceDocuments`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            const result = await response.json();
            if (result.status === 1) {
                this.refreshData(); // بروزرسانی لیست قیمت‌گذاری‌ها
            } else {
                // مدیریت خطا
                console.error('Error:', result.message);
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }

    handleTabClick(tab) {
        this.setState({ activeTab: tab });
    }

    renderPricingList() {
        const columns = [
            {
                name: 'ردیف',
                selector: (row, index) => this.genRowNumber(index),
                center: true,
                sortable: true,
                width: '100px',
            },
            {
                name: 'تاریخ قیمت‌گذاری',
                selector: row => new Date(row.pricingDate).toLocaleDateString('fa-IR'),
                sortable: true,
            },
            {
                name: 'روش قیمت‌گذاری',
                selector: row => row.pricingMethod,
                sortable: true,
            },
            {
                name: 'تاریخ شروع',
                selector: row => new Date(row.startDate).toLocaleDateString('fa-IR'),
                sortable: true,
            },
            {
                name: 'تاریخ پایان',
                selector: row => new Date(row.endDate).toLocaleDateString('fa-IR'),
                sortable: true,
            },
            {
                name: 'عملیات',
                cell: row => (
                    <ul className="nk-tb-actions gx-1">
                        <li>
                            <div className="dropdown">
                                <a href="#" className="dropdown-toggle btn btn-icon btn-trigger" data-bs-toggle="dropdown"><em className="icon ni ni-more-h"></em></a>
                                <div className="dropdown-menu dropdown-menu-end">
                                    <ul className="link-list-opt no-bdr">
                                        <li><NavLink to={`/pricing/edit/${row.id}/`}><em className="icon ni ni-eye"></em><span>مشاهده و ویرایش</span></NavLink></li>
                                        <li><a className="hand" onClick={() => this.confirmRemove(row.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove"><em className="icon ni ni-na"></em><span>حذف رکورد</span></a></li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                    </ul>
                ),
                ignoreRowClick: true,
                allowOverflow: true,
                button: true,
                center: true,
            },
        ];

        return (
            <DataTable
                columns={columns}
                data={this.state.data}
                customStyles={customStyles}
                pagination
                paginationServer
                paginationTotalRows={this.state.data ? this.state.data.length : 0}
                onChangePage={page => this.setState({ page })}
                onChangeRowsPerPage={per_page => this.setState({ per_page })}
                progressPending={this.state.loading}
            />
        );
    }

    renderForm() {
        return (
            <form onSubmit={this.handleFetchRemittances}>
                <div className="form-group">
                    <label>تاریخ شروع</label>
                    <input
                        type="date"
                        name="startDate"
                        className="form-control"
                        value={this.state.startDate}
                        onChange={this.handleInputChange}
                    />
                </div>
                <div className="form-group">
                    <label>تاریخ پایان</label>
                    <input
                        type="date"
                        name="endDate"
                        className="form-control"
                        value={this.state.endDate}
                        onChange={this.handleInputChange}
                    />
                </div>
                <button type="submit" className="btn btn-primary">دریافت اطلاعات</button>
                <button onClick={this.handlePriceDocuments} className="btn btn-success" style={{ marginLeft: '10px' }}>قیمت‌گذاری</button>
            </form>
        );
    }

    render() {
        const { activeTab } = this.state;

        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :

            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {/*this.isEmptyAnnualsOrCompanies(this.state.data?.global) ? this.renderNoCompanyOrAnnualRegister() : */this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}
